/* export class Ramp {
    
    id: number;
    brojRampe: string;
    ulazna: boolean;
    izlazna: boolean;
    roomId: null;
    roomName: string;
  
  
   
        constructor(ramp?:Ramp) {
            if(ramp){
            this.id = ramp.id;
            this.ulazna =ramp.ulazna;
            this.izlazna=ramp.izlazna;
            this.roomId=ramp.roomId;
            this.brojRampe=ramp.brojRampe;
           this.roomName=ramp.roomName;
            }
            if(this.brojRampe==null){
                this.brojRampe='';
             }
             if(this.roomName==null){
               this.roomName='';
            }
          }
  } */
  export class Ramp {
    [x: string]: any;
  /*  id: number; */
  brojRampe:string
   ulazna: boolean;
   izlazna: boolean;
   roomName: string;
    roomId:number;
   constructor() {
    /*  this.id = null; */
     this.brojRampe = '';
     this.ulazna = false;
     this.izlazna = false;
     this.roomName = '';
    this.roomId=null;
 
   }
 }
  